import { render, staticRenderFns } from "./PritickePack07.vue?vue&type=template&id=9da48c30&scoped=true&"
import script from "./PritickePack07.vue?vue&type=script&lang=js&"
export * from "./PritickePack07.vue?vue&type=script&lang=js&"
import style0 from "./PritickePack07.vue?vue&type=style&index=0&id=9da48c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da48c30",
  null
  
)

export default component.exports